import { autorun } from 'mobx';
import { useEffect, useState } from 'react';
import _isArray from 'lodash/isArray';

import type { Store } from '@/stores';

export function useMapStoreStateToClientState<StoreType, ReturnType>(
  store: Store | StoreType,
  storePropsSelectionFunc: (store: Store | StoreType) => ReturnType,
  dependencies?: Array<any>
): ReturnType {
  const [state, setState] = useState(storePropsSelectionFunc(store));

  const deps = _isArray(dependencies) ? dependencies : [];

  useEffect(
    () =>
      autorun(() => {
        setState(storePropsSelectionFunc(store));
      }),
    [store, ...deps]
  );

  return state;
}
